import React, { useEffect, useState } from "react";
import MainNav from "./navigation/main-nav";
import Intro from "./intro/intro";
import About from "./about/about";
import Classes from "./classes/classes";
import Gallery from "./gallery/gallery";
import Events from "./events/events";
import Contact from "./contact/contact";
import Offers from "./offers/offers";
import Footer from "./footer/footer";
import { fetchContent, mapContent } from "./actions";

function App() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      const result = await fetchContent();
      return result;
    };

    loadContent()
      .then(data => {
        const mapped = mapContent(data.response);
        setContent(mapped);
      })
      // eslint-disable-next-line no-console
      .catch(error => console.log(error));
  }, []);

  if (!content) {
    return <></>;
  }

  return (
    <>
      <MainNav />
      <Intro />
      <About
        title={content.aboutSection.title}
        text={content.aboutSection.text}
      />
      <Classes
        classes={content.classes}
        title={content.classesSection.title}
        text={content.classesSection.text}
      />
      <Gallery gallery={content.gallery} />
      <Events events={content.events} title={content.eventsSection.title} />
      <Contact
        contact={content.contact}
        title={content.contactSection.title}
        text={content.contactSection.text}
      />
      <Offers
        title={content.offersSection.title}
        text={content.offersSection.text}
      />
      <Footer />
    </>
  );
}

export default App;
